module.exports = __webpack_public_path__ + "static/chitine-671b64626d1b63d6d20c9d7299d0cc98.jpeg";